
export class ProjectInfo {
  ProjectId: number
  ProjectCode: string
  ProjectName: string
  ProjectShortName: string
  ProjectTypeCode: string
  ProjectTypeName: string
  POOrderNo: string
  POOrderFileName: string
  POOrderPathFile: string
  WorkOrderNo: string
  WorkOrderFileName: string
  WorkOrderPathFile: string
  ProjectImgPath: string
  ProjectStart: string
  ProjectEnd: string
  ProjectStatusCode: string
  ProjectStatusName: string
  ProjectStateCode: string
  ProjectStateName: string
  ProjectSupportContractTypeCode: string
  ProjectSupportContractTypeValue: string
  ProjectSupportContractTypeDisplay: string
  ProjectWarrantyTypeCode: string
  ProjectWarrantyTypeName: string
  ProjectMATypeCode: string
  ProjectMATypeName: string
  ProjectWarrantyStart: string
  ProjectWarrantyEnd: string
  ProjectMAStart: string
  ProjectMAEnd: string
  ProjectPackage: number
  ProjectCompanyCode: string
  ProjectCompanyName: string
  CustomerCode: string
  CustomerName: string
  Comment: string
  UpdateDate: string
  UpdateBy: string
  CreateDate: string
  CreateBy: string
  countProject: number
  rowOFFSet: number
  rowFetch: number
  FlagDelete: string

  ProjectSubscriptType:string
  ProjectSubscriptStart: string
  ProjectSubscriptEnd: string
  ProjectPerputualType: string

  ProjectAssignPM: string
  ProjectAssignManagerSupport: string

  ProjectAssignPMDisplay: string
  ProjectAssignManagerSupportDisplay: string

  ProjectAssignPCO: string
  ProjectAssignPCODisplay: string

  ProjectSubType: string
  ProjectSubTypeDisplay: string
  ParentProjectCode: string

  countTotal: number
}


